import React from 'react'
import { Row, Col, Card, CardHeader, CardBody, CardTitle } from 'reactstrap'

const Descriptions = (props) => {
    return (
        <Row>
            <Col xs="12">
                <Card>
                    <CardHeader>
                        <Row>
                            <Col className="text-right" sm="6">
                                <CardTitle tag="h5"><i className="tim-icons icon-bulb-63 text-info" />تعریف مفاهیم</CardTitle>
                            </Col>
                        </Row>
                    </CardHeader>
                    <CardBody className="text-right">
                        <p></p>
                        <p className="text-justify">
                            <span className="category-description">همسر آزاری: </span>
                            «میانگین نمرات افراد در مقیاس همسرآزاری که انواع مختلف آزارهای صورت گرفته نسبت به همسر از جمله بدرفتاری جسمی (شامل آزارهایی نظیر کتک زدن، مجروح کردن و سوزاندن) بدرفتاری عاطفی (شامل آزارهایی نظیر تحقیر کردن و محدود کردن زنان از اشتغال، ادامۀ تحصیل و دیگر فعالیت‌های دلخواه) و بدرفتاری جنسی (شامل آزار نسبت به همسر در زمینۀ جنسی) را نشان می دهد. میانگین نمره محاسبه شده برای شاخص همسرآزاری بین 0 تا 95 می‌باشد.
                        </p>
                        <p className="text-justify">
                            <span className="category-description">ادراک فساد: </span>
                            «میانگین نمرات افراد در مقیاس ادراک فساد که سوءاستفاده از قدرت برای کسب منافع مالی فردی یا گروهی (نظیر اختلاس، رشوه و پارتی‌بازی) را نشان می دهد». میانگین نمره محاسبه شده برای شاخص ادراک فساد بین 0 تا 5 می‌باشد.
                        </p>
                        <p className="text-justify">
                            <span className="category-description">روابط غیرازدواجی: </span>
                            «هر نوع ارتباط عشقی، تماس بدنی (بدون رابطۀ کامل جنسی) یا رابطۀ کامل جنسی توسط فردی متأهل با فردی از جنسیت دیگر (به غیر از همسر خودش) یا توسط فردی مجرد با فردی از جنسیت دیگر»
                        </p>
                        <p className="text-justify">
                            <span className="category-description">پیشنهاد رشوه: </span>
                            «پیشنهاد پرداخت هزینۀ اضافی خارج از روال اداری به افراد شاغل (در سازمان‌های اداری دولتی، خصوصی یا عمومی) برای انجام کاری خلاف قانون یا تسریع در انجام فرآیند کار در طول یک سال گذشته».
                        </p>
                        <p className="text-justify">
                            <span className="category-description">دریافت رشوه: </span>
                            «دریافت هزینۀ اضافی خارج از روال اداری توسط افراد شاغل (در سازمان‌های اداری دولتی، خصوصی یا عمومی) برای انجام کاری خلاف قانون یا تسریع در انجام فرآیند کار در طول یک سال گذشته».
                        </p>
                        <p className="text-justify">
                            <span className="category-description">اعتیاد به مواد: </span>
                            «مصرف یک بار در طول عمر یا هر روزۀ مواد اعتیادآور شامل تنباکو، الکل، مواد افیونی، مواد محرک، کانابینوئیدها و داروهای خواب آور».
                        </p>
                        <p className="text-justify">
                            <span className="category-description">روسپیگری: </span>
                            «رابطۀ جنسی کامل یک زن با مردی غیر از همسرش با هدف کسب پول یا کمک غیرنقدی».
                        </p>
                        <p>&nbsp;</p>
                    </CardBody>
                </Card>
            </Col>
        </Row>
    )
}

export default Descriptions;